"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const domComputed_1 = require("./domComputed");
function create(fn, ...args) {
    return domComputed_1.domComputedOwned(null, (owner) => {
        const value = ('create' in fn) ?
            fn.create(owner, ...args) :
            fn(owner, ...args);
        return (value && typeof value === 'object' && 'buildDom' in value) ?
            value.buildDom() : value;
    });
}
exports.create = create;
//# sourceMappingURL=domComponent.js.map